import { sanitizeParameter } from '@thg-commerce/enterprise-utils'
import {
  EnterpriseNextPageContext,
  getSafeUrlParametersFromReq,
} from '@thg-commerce/enterprise-core'

export const getInfoFromQueryParam = (
  queryParam: string | string[],
): { slug: string; page?: number } => {
  if (typeof queryParam === 'string') {
    return { slug: sanitizeParameter(queryParam) }
  }
  if (
    queryParam?.includes('page') &&
    queryParam?.indexOf('page') === queryParam.length - 2
  ) {
    return {
      slug: sanitizeParameter(queryParam[queryParam.length - 3] || ''),
      page: parseInt(
        sanitizeParameter(queryParam[queryParam.length - 1]),
        undefined,
      ),
    }
  }

  return { slug: sanitizeParameter(queryParam[queryParam.length - 1]) }
}

export const getPaginationVaribles = (
  page: number,
  amount: number,
): { offset: number; limit: number } => {
  const offset = amount * page - amount

  return {
    offset,
    limit: amount,
  }
}

export const getPathAndParamsFromReq = (
  ctx: EnterpriseNextPageContext,
): {
  path: string
  pageParams: {
    pageNumber?: string
    facetFilters?: string
    sortOrder?: string
  }
} => {
  const {
    path,
    pageNumber,
    facetFilters,
    sortOrder,
  } = getSafeUrlParametersFromReq(ctx, [
    'path',
    'pageNumber',
    'facetFilters',
    'sortOrder',
  ]) as {
    path: string[]
    pageNumber?: string
    facetFilters?: string
    sortOrder?: string
  }

  if (!path || !path?.length) {
    return { path: '', pageParams: {} }
  }
  const cleanedPath = path.map((item) =>
    encodeURIComponent(decodeURIComponent(item).replace(/(\b\.list|\/)/g, '')),
  )

  return {
    path: `/${cleanedPath.join('/')}`,
    pageParams: {
      sortOrder,
      pageNumber,
      facetFilters: facetFilters ? decodeURIComponent(facetFilters) : undefined,
    },
  }
}

export const pastContentDate: string = new Date(
  Date.now() - 34560000000,
).toDateString()
